import React, { useCallback, useMemo } from "react";
import { Button, Link, TableCellLayout } from "@fluentui/react-components";
import {
  useCreateExcelSheetAndAppend,
  useCreateNewExcel,
  useDownloadExcel,
} from "hooks/useExcelJs";
import moment from "moment";
import { DocumentDatabaseFilled } from "@fluentui/react-icons";
import { SearchResult } from "types/service/searchResult";
import { useSearchExport } from "hooks/useSearch";
import { PerDecomp } from "types/OnDemand.types";

export type DownloadFileButtonProps<T> = {
  items: T[];
  dataset: string;
  cnpj: string;
  companyName: string;
  enabled?: boolean;
};

export const DownloadFileButton = <T,>({
  items,
  cnpj,
  dataset,
  companyName,
  enabled,
}: DownloadFileButtonProps<T>) => {
  if (enabled == false) return <></>;
  let link: JSX.Element = null;
  companyName = companyName.split(" ").join("_");
  // const { exportFile } = useSearchExport();
  const parseExcel = useCallback(async () => {
    const excelBook = useCreateNewExcel();
    // var data = await exportFile(id);
    useCreateExcelSheetAndAppend({
      book: excelBook,
      data: Object.values(items),
      sheetName: `${moment().format(`DD-MM-YYYY`)}`,
    });
    useDownloadExcel(
      excelBook,
      `${cnpj}-${companyName}-${dataset}-${moment().format("DDMMYYYY")}.xlsx`,
    );
  }, []);
  link = <Link onClick={() => parseExcel()}>{cnpj}</Link>;
  return (
    <>
      <Button onClick={parseExcel} icon={<DocumentDatabaseFilled />}>
        Download excel
      </Button>
    </>
  );
};
